import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import async from 'async';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import RegistryContainer from '../../containers/Registry';

import { Button, CircularProgress, DialogActions, Zoom } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import FormComponent from '../FormComponent';
import FMPText from '../pureForm/FMPText';
import Transition from './Transition';

const styles = (theme) => ({
	paper: {
		width: '100%',
		overflowX: 'auto',
	},
	dialogPadding: {
		padding: 10,
		[theme.breakpoints.up('md')]: {
			padding: '20px 50px 20px 50px',
		},
	},
	dialogPaper: {
		overflow: 'scroll',
		maxHeight: 'calc(100% - 20px)',
		margin: 10,
	},
});

function getRegValue(registryRows, name) {
	return _.get(_.find(registryRows, { name }), 'val');
}

function getRegId(registryRows, name) {
	return _.get(_.find(registryRows, { name }), 'registryId');
}

class PriceSettingsDialog extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			isSaving: false,
			pricingRequestMaxPrice: '',
			pricingRequestMinPrice: '',
		};
	}
	componentDidMount() {
		if (!this.props.registryRows) {
			this.props.searchRegistry({});
		}
	}

	componentDidUpdate(prevProps) {
		const { registryRows } = this.props;
		if (!prevProps.registryRows && registryRows) {
			const pricingRequestMinPrice = getRegValue(registryRows, 'pricingRequestMinPrice');
			const pricingRequestMaxPrice = getRegValue(registryRows, 'pricingRequestMaxPrice');

			const pricingRequestMinPriceId = getRegId(registryRows, 'pricingRequestMinPrice');
			const pricingRequestMaxPriceId = getRegId(registryRows, 'pricingRequestMaxPrice');

			this.setState({
				pricingRequestMinPrice,
				pricingRequestMaxPrice,
				pricingRequestMinPriceId,
				pricingRequestMaxPriceId,
			});
		}
	}

	handleClose = () => {
		this.setState(
			{
				isSaving: false,
			},
			this.props.onClose
		);
	};

	handleSubmitSettings = () => {
		const { updateRegistry, showErrors } = this.props;

		const {
			pricingRequestMinPrice,
			pricingRequestMaxPrice,
			pricingRequestMinPriceId,
			pricingRequestMaxPriceId,
		} = this.state;

		const formFieldError = {};
		const minPrice = parseFloat(pricingRequestMinPrice);
		const maxPrice = parseFloat(pricingRequestMaxPrice);

		if (!_.isNumber(minPrice)) {
			formFieldError.pricingRequestMinPrice = 'Min price need to be a valid number.';
		}

		if (!_.isNumber(maxPrice)) {
			formFieldError.pricingRequestMaxPrice = 'Max price need to be a valid number.';
		}

		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		this.setState({
			isSaving: true,
		});
		async.waterfall(
			[
				(callback) => {
					updateRegistry({
						params: {
							registryId: pricingRequestMinPriceId,
							val: minPrice.toFixed(2),
						},
						callback,
					});
				},
				(_r, callback) => {
					updateRegistry({
						params: {
							registryId: pricingRequestMaxPriceId,
							val: maxPrice.toFixed(2),
						},
						callback,
					});
				},
			],
			(err) => {
				this.setState({
					isSaving: false,
				});
				if (err) {
					showErrors([err]);
				}
				return;
			}
		);
	};

	render() {
		const { classes, open, fullScreen } = this.props;
		const { isSaving } = this.state;
		return (
			<Dialog
				maxWidth="md"
				fullScreen={fullScreen}
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{ paper: classes.dialogPaper }}
				fullWidth={true}
			>
				<div className={classes.dialogPadding}>
					<DialogTitle>SMS Price Settings</DialogTitle>
					<DialogContent>
						<FMPText
							helpText="Lesser values will trigger a triage alert"
							{...this.setForm(
								`pricingRequestMinPrice`,
								'Minimum automatically accepted price',
								true
							)}
						/>

						<FMPText
							helpText="Greater values will trigger a triage alert"
							{...this.setForm(
								`pricingRequestMaxPrice`,
								'Maximum automatically accepted price',
								true
							)}
						/>

						<Zoom
							in={isSaving}
							style={{ transitionDelay: isSaving ? '0ms' : '0ms' }}
							mountOnEnter
							unmountOnExit
						>
							<div className={classes.isSaving}>
								<CircularProgress style={{ verticalAlign: 'middle' }} />
								<span style={{ paddingLeft: 10 }}>Saving...</span>
							</div>
						</Zoom>
					</DialogContent>

					<DialogActions>
						<Button onClick={this.handleClose}>Cancel</Button>
						<Button
							disabled={isSaving}
							variant="contained"
							onClick={this.handleSubmitSettings}
							className={classes.submitButton}
							color="primary"
						>
							Update Price Settings
						</Button>
					</DialogActions>
				</div>
			</Dialog>
		);
	}
}

PriceSettingsDialog.propTypes = {
	fullScreen: PropTypes.bool.isRequired,
	classes: PropTypes.object.isRequired,
	open: PropTypes.bool,
	onClose: PropTypes.func.isRequired,

	searchRegistry: PropTypes.func,
	updateRegistry: PropTypes.func,
	registryRows: PropTypes.array,
};

export default _.flow([withStyles(styles), withMobileDialog(), RegistryContainer])(
	PriceSettingsDialog
);
